import * as XLSX from "xlsx";
import { numberFormat } from "../helpers";

export const exportOrdersCustomFormat = (groups, title, rateData) => {
  let rows = [];
  let totalQty = 0;
  let sumKip = 0;
  let sumUsd = 0;
  
  // Group all orders by cfMessage across all order groups
  const groupedByCfMessage = {};
  groups.forEach((group) => {
    const orders = group?.orders || [];
    
    orders.forEach((order) => {
      const cfMessage = order?.cfMessage || "";
      const currency = order?.currency || order?.stock?.currency || "";
      
      // Group ONLY by cfMessage (not cfMessage + cfName)
      if (!groupedByCfMessage[cfMessage]) {
        groupedByCfMessage[cfMessage] = {
          cfMessage: cfMessage,
          productName: order?.productName || order?.stock?.name || "",
          currency: currency,
          totalQty: 0,
          baseTotal: 0
        };
      }
      
      const qty = parseInt(order?.amount || 0);
      const price = parseFloat(order?.price || 0);
      const baseTotal = parseFloat(order?.totalPrice || qty * price || 0);
      
      groupedByCfMessage[cfMessage].totalQty += qty;
      groupedByCfMessage[cfMessage].baseTotal += baseTotal;
    });
  });
  
  // Create rows for each grouped cfMessage
  Object.values(groupedByCfMessage).forEach((grouped) => {
    const { cfMessage, productName, currency, totalQty: groupedTotalQty, baseTotal } = grouped;
    
    let kipValue = 0;
    let usdValue = 0;
    if (["LAK", "ກີບ"].includes(currency)) {
      kipValue = baseTotal;
    } else if (["BAHT", "ບາດ"].includes(currency)) {
      kipValue = baseTotal * parseFloat(rateData?.baht || 0);
    } else if (["USD", "ໂດລາ"].includes(currency)) {
      usdValue = baseTotal;
    }
    
    totalQty += groupedTotalQty;
    sumKip += kipValue;
    sumUsd += usdValue;
    
    rows.push({
      "#": rows.length + 1,
      "ລະຫັດ CF": cfMessage,
      "ຊື່ສິນຄ້າ": productName,
      "ຈຳນວນ": groupedTotalQty,
      "ລາຄາ": baseTotal / groupedTotalQty, // Average price per unit
      "KIP": kipValue ? new Intl.NumberFormat("en-US").format(kipValue) : "",
      "USD": usdValue ? new Intl.NumberFormat("en-US").format(usdValue) : "",
    });
  });
  
  const columns = ["#", "ລະຫັດ CF", "ຊື່ສິນຄ້າ", "ຈຳນວນ", "ລາຄາ", "KIP", "USD"];
  const headerRow = [[title]];
  const header = [columns];
  const aoa = [...headerRow, ...header, ...rows.map(r => columns.map(c => r[c]))];
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = [
    { wch: 6 },
    { wch: 14 },
    { wch: 40 },
    { wch: 10 },
    { wch: 12 },
    { wch: 16 },
    { wch: 12 },
  ];
  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];
  const sumRow = [
    "",
    "ລວມ",
    "",
    totalQty,
    "",
    new Intl.NumberFormat("en-US").format(sumKip),
    new Intl.NumberFormat("en-US").format(sumUsd),
  ];
  XLSX.utils.sheet_add_aoa(ws, [sumRow], { origin: -1 });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Report");
  XLSX.writeFile(wb, `order_custom_format_${new Date().toISOString().split("T")[0]}.xlsx`);
};
